import { useState, useEffect } from "react";
import {
  Button, Card, Table, Container, Row, Col, Input, CardFooter, Label,
} from "reactstrap";
import { reportmanageService } from "../../../services/reportmanageService";
import { taskmanageService } from "../../../services/taskmanageService";
import "../../../assets/css/custom.css";
import Header from "components/Headers/Header.js";
import Paginationcomponent from "components/Paginationcomponent.js";

const DocumentTypeEditReport = () => {
  const [activeTab, setActiveTab] = useState("summary");

  // ---- Summary state ----
  const [changes, setChanges] = useState([]);
  const [byFromType, setByFromType] = useState([]);
  const [failures, setFailures] = useState([]);
  const [totals, setTotals] = useState({ total_edits: 0, total_changes: 0, total_failures: 0 });
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');

  // ---- Details state ----
  const [details, setDetails] = useState([]);
  const [detailFrom, setDetailFrom] = useState('');
  const [detailTo, setDetailTo] = useState('');
  const [changedOnly, setChangedOnly] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [detailsLoaded, setDetailsLoaded] = useState(false);
  const rowsPerPageOptions = [5, 10, 25, 50, 100];

  useEffect(() => {
    loadSummary('', '');
  }, []);

  function loadSummary(f, t) {
    reportmanageService.getDocumentTypeEditReport(f, t).then((response) => {
      if (response && response.data) {
        setChanges(response.data.changes || []);
        setByFromType(response.data.by_from_type || []);
        setFailures(response.data.failures || []);
        setTotals(response.data.totals || { total_edits: 0, total_changes: 0, total_failures: 0 });
      }
    });
  }

  function loadDetails(page = 1) {
    reportmanageService
      .getDocumentTypeEditReportDetails(detailFrom, detailTo, changedOnly ? 1 : 0, page, rowsPerPage)
      .then((response) => {
        if (response && response.data && response.data.data) {
          const paginator = response.data.data;
          setDetails(paginator.data || []);
          setCurrentPage(paginator.current_page || 1);
          setTotalItems(paginator.total || 0);
        }
      });
  }

  function switchTab(tab) {
    setActiveTab(tab);
    if (tab === "details" && !detailsLoaded) {
      setDetailsLoaded(true);
      loadDetails(1);
    }
  }

  // Summary handlers
  function applySummary() { loadSummary(from, to); }
  function resetSummary() { setFrom(''); setTo(''); loadSummary('', ''); }
  function downloadSummary() { reportmanageService.exportDocumentTypeEditReport(from, to); }

  // Details handlers
  function applyDetails() { loadDetails(1); }
  function resetDetails() {
    setDetailFrom(''); setDetailTo(''); setChangedOnly(false);
    setTimeout(() => loadDetails(1), 50);
  }
  function downloadDoc(item) {
    taskmanageService.download_file(item.doc_path, item.file_name, item.file_extension, item.task_id, item.s3_bucket);
  }
  function openTask(taskId) {
    window.open(`/admin/task/${taskId}/documents`, "_blank");
  }

  const handlePageClick = (page) => { setCurrentPage(page); loadDetails(page); };
  const handlePreviousClick = () => { if (currentPage > 1) handlePageClick(currentPage - 1); };
  const handleNextClick = () => { if (currentPage < Math.ceil(totalItems / rowsPerPage)) handlePageClick(currentPage + 1); };
  const handleRowsPerPageChange = (e) => { setRowsPerPage(parseInt(e.target.value)); setTimeout(() => loadDetails(1), 50); };

  function formatDate(dateStr) {
    if (!dateStr) return '—';
    const d = new Date(dateStr);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    return `${day}-${month}-${d.getFullYear()}`;
  }

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <div className="mb-4" style={{ borderBottom: "2px solid #e9ecef", paddingBottom: "10px" }}>
          <Button
            color="primary"
            outline={activeTab !== "summary"}
            onClick={() => switchTab("summary")}
            style={{ marginRight: "10px" }}
          >
            Summary
          </Button>
          <Button
            color="primary"
            outline={activeTab !== "details"}
            onClick={() => switchTab("details")}
          >
            Details
          </Button>
        </div>

        {activeTab === "summary" && (
          <div>
            <Row className="mb-3">
              <Col xl="3"><label>From</label><Input type="date" value={from} onChange={(e) => setFrom(e.target.value)} /></Col>
              <Col xl="3"><label>To</label><Input type="date" value={to} onChange={(e) => setTo(e.target.value)} /></Col>
              <Col xl="3" style={{ paddingTop: '32px' }}>
                <Button color="primary" size="sm" onClick={applySummary}>Filter</Button>
                <Button color="secondary" size="sm" onClick={resetSummary}>Reset</Button>
              </Col>
              <Col xl="3" style={{ paddingTop: '32px', textAlign: 'right' }}>
                <Button className="btn-icon-clipboard" type="button" onClick={downloadSummary} title="Download Report">
                  <i className="fas fa-download" style={{ fontSize: '14px' }}></i> Export
                </Button>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col xl="4"><Card body><h3>{totals.total_edits}</h3><span>Total Type Edits</span></Card></Col>
              <Col xl="4"><Card body><h3>{totals.total_changes}</h3><span>Type Changes (old ≠ new)</span></Card></Col>
              <Col xl="4"><Card body><h3>{totals.total_failures}</h3><span>Job Failures</span></Card></Col>
            </Row>

            <Row>
              <Col xl="7">
                <Card style={{ marginBottom: "10px" }}>
                  <Table responsive size="sm" style={{ fontSize: '12px' }}>
                    <thead className="thead-light"><tr><th>Sr.No.</th><th>Previous Type</th><th>Changed To</th><th>Count</th></tr></thead>
                    <tbody>
                      {changes && changes.length ? changes.map((item, index) => (
                        <tr key={index}><td>{index + 1}</td><td>{item.from_type}</td><td>{item.to_type}</td><td>{item.count}</td></tr>
                      )) : (<tr><td colSpan={4}>No records found</td></tr>)}
                    </tbody>
                  </Table>
                </Card>
              </Col>
              <Col xl="5">
                <Card style={{ marginBottom: "10px" }}>
                  <Table responsive size="sm" style={{ fontSize: '12px' }}>
                    <thead className="thead-light"><tr><th>Type</th><th>Total Edits</th><th>Changes</th></tr></thead>
                    <tbody>
                      {byFromType && byFromType.length ? byFromType.map((item, index) => (
                        <tr key={index}><td>{item.from_type}</td><td>{item.total_edits}</td><td>{item.total_changes}</td></tr>
                      )) : (<tr><td colSpan={3}>No records found</td></tr>)}
                    </tbody>
                  </Table>
                </Card>
                <Card style={{ marginBottom: "10px" }}>
                  <Table responsive size="sm" style={{ fontSize: '12px' }}>
                    <thead className="thead-light"><tr><th>Failure Stage</th><th>Count</th></tr></thead>
                    <tbody>
                      {failures && failures.length ? failures.map((item, index) => (
                        <tr key={index}><td>{item.stage}</td><td>{item.count}</td></tr>
                      )) : (<tr><td colSpan={2}>No records found</td></tr>)}
                    </tbody>
                  </Table>
                </Card>
              </Col>
            </Row>
          </div>
        )}

        {activeTab === "details" && (
          <div>
            <Row className="mb-3">
              <Col xl="3"><label>From</label><Input type="date" value={detailFrom} onChange={(e) => setDetailFrom(e.target.value)} /></Col>
              <Col xl="3"><label>To</label><Input type="date" value={detailTo} onChange={(e) => setDetailTo(e.target.value)} /></Col>
              <Col xl="3" style={{ paddingTop: '30px' }}>
                <Label check style={{ fontSize: '13px' }}>
                  <Input type="checkbox" checked={changedOnly} onChange={(e) => setChangedOnly(e.target.checked)} />{' '}
                  Only AI got it wrong (type changed)
                </Label>
              </Col>
              <Col xl="3" style={{ paddingTop: '28px', textAlign: 'right' }}>
                <Button color="primary" size="sm" onClick={applyDetails}>Filter</Button>
                <Button color="secondary" size="sm" onClick={resetDetails}>Reset</Button>
              </Col>
            </Row>

            <Row>
              <Col xl="12">
                <Card style={{ padding: '0px', marginBottom: "10px" }}>
                  <Table className="align-items-center table-flush" responsive size="sm" style={{ fontSize: '12px' }}>
                    <thead className="thead-light">
                      <tr>
                        <th>Sr.No.</th><th>Date</th><th>Client / Company</th><th>Task</th>
                        <th>Previous (AI) Type</th><th>New Type</th><th>Edited By</th><th>Download</th>
                      </tr>
                    </thead>
                    <tbody>
                      {details && details.length ? details.map((item, index) => (
                        <tr key={item.id}>
                          <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                          <td>{formatDate(item.created_at)}</td>
                          <td className="whitespace">{item.company_name || '—'}{item.sub_client ? ` (${item.sub_client})` : ''}</td>
                          <td>
                            {item.task_id ? (
                              <Button color="link" size="sm" style={{ padding: 0 }} onClick={() => openTask(item.task_id)}>#{item.task_id}</Button>
                            ) : '—'}
                          </td>
                          <td>{item.old_value || '—'}</td>
                          <td>{item.new_value || '—'}</td>
                          <td className="whitespace">{item.edited_by || '—'}</td>
                          <td>
                            {item.doc_path ? (
                              <Button color="primary" size="sm" onClick={() => downloadDoc(item)} title="Download document">
                                <i className="fas fa-download"></i>
                              </Button>
                            ) : (<span style={{ color: '#999' }}>N/A</span>)}
                          </td>
                        </tr>
                      )) : (<tr><td colSpan={8}>No records found</td></tr>)}
                    </tbody>
                  </Table>
                  <CardFooter className="py-4">
                    <Paginationcomponent
                      currentPage={currentPage}
                      totalItems={totalItems}
                      rowsPerPage={rowsPerPage}
                      rowsPerPageOptions={rowsPerPageOptions}
                      handlePageClick={handlePageClick}
                      handlePreviousClick={handlePreviousClick}
                      handleNextClick={handleNextClick}
                      handleRowsPerPageChange={handleRowsPerPageChange}
                    />
                  </CardFooter>
                </Card>
              </Col>
            </Row>
          </div>
        )}
      </Container>
    </>
  );
};

export default DocumentTypeEditReport;
